import * as React from 'react';

const MINIMUM_WIDTH = 800;

export function useMinimumWidth() {
  const [ isWidthSufficient, setIsWidthSufficient ] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const checkWidth = () => {
      setIsWidthSufficient(window.innerWidth >= MINIMUM_WIDTH);
    };

    // Check on mount
    checkWidth();

    // Listen for resize events
    window.addEventListener('resize', checkWidth);

    return () => {
      window.removeEventListener('resize', checkWidth);
    };
  }, []);

  return {
    isWidthSufficient: !!isWidthSufficient,
    currentWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
    minimumWidth: MINIMUM_WIDTH
  };
}
